/**
 * Render toolbar
 *
 * @author: Mozart Diniz
 * Date: 07/02/13
 * Time: 14:41
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.LocationGeocode = Greenmile.Toolbar.Map.LocationGeocode || {};

Greenmile.Toolbar.Map.LocationGeocode = function (selector, map) {

    if (!selector || !map) {
        return false;
    }

    this.addListeners = () => {

        const $input = $(`${selector} input[name='searchStreet']`);

        $input.on("keyup", (e) => {
            const inputText = $(selector + " input[name='searchStreet']").val();

            if(inputText.length === 0) {
                const searchListBox = $(selector + " .streetSearchResult");
                searchListBox.html('');
                searchListBox.hide();
            }
        });

        $input.on("keydown", e => {
            if (e.keyCode === 40) {
                this.canHide = false;
                $(selector + " .streetSearchResult select").trigger("focus");
                $(selector + " .streetSearchResult select").val($(selector + " .streetSearchResult select option:first").val());
            } else {
                const { requestGeocodeTimeoutId } = Monet.Session.Location.Geofence
                if (requestGeocodeTimeoutId) {
                    clearTimeout(requestGeocodeTimeoutId);
                }
                Monet.Session.Location.Geofence.requestGeocodeTimeoutId = setTimeout(this.requestGeocode, 750);
            }
        });

        $input.on("blur",
            () => {
                if (this.canHide === true) {
                    $(selector + " .streetSearchResult").hide();
                    $(selector + " .streetSearchResult").html();
                    $input.val("");
                    this.canHide === false;
                }
            }
        );

        $(selector + " .streetSearchResult").on("mouseover", () => (this.canHide = false));

        $(selector + " .streetSearchResult select").on('keydown',
            e => {
                if (e.keyCode === 13) {
                    var opt = $(selector + " .streetSearchResult select option:selected");
                    var lat = opt.attr("lat");
                    var lng = opt.attr("lng");
                    var address = opt.attr("address");
                    var kind = opt.attr("kind");
                    Greenmile.Toolbar.Map.Util.addMarkerToMap(lat, lng, address, null, kind, map);
                }
        });

    };

    this.requestGeocode = () => {
      const gGeocode = new Greenmile.Geocoding.Google();
      const address = document.querySelector(`${selector} input[name='searchStreet']`).value;
      gGeocode.geocode(address, this.renderGeocodeResult, this.renderGeocodeResult);
    };

    this.selectItem = () => {
      var opt = $(selector + " .streetSearchResult select option:selected");
      var lat = opt.attr("lat");
      var lng = opt.attr("lng");
      var htmlPop = document.createElement('div');
      var btn = document.createElement('input');
      var address = opt.attr("address");

      btn.type = 'button';
      btn.value = Monet.I18n.getResourcesByKey('Location.Geocode.ConfirmPosition');
      btn.className = 'locationGeocodeConfirmBtn';

      htmlPop.innerHTML = address;
      htmlPop.appendChild(btn);

      var kind = opt.attr("kind");
      var layers = Monet.Session.Location.Geofence.map._layers;
      var llMarker, geoMarker, bounds = [];

      for (var l in layers) {
          if (layers[l].kind === 'marker_address') {
              map.removeLayer(layers[l]);
          }
      }

      Greenmile.Toolbar.Map.Util.addMarkerToMap(lat, lng, htmlPop, null, kind, map);

      $(selector + " .streetSearchResult").hide();
      $(selector + " .streetSearchResult").html();
      $(selector + " input[name='searchStreet']").val("");

      for (var m in layers) {
          if (layers[m].kind === 'LATLNG_MARKER') {
              llMarker = layers[m];
          } else if (layers[m].kind === 'marker_address') {
              geoMarker = layers[m];
          }
      }

      if (llMarker) {
          bounds.push([llMarker._latlng.lat, llMarker._latlng.lng]);
      }

      if (geoMarker) {
          Monet.Session.Location.Geofence.locationNewPosition = geoMarker;
          bounds.push([geoMarker._latlng.lat, geoMarker._latlng.lng]);
      }

      btn.addEventListener('click', () => {
        geoMarker.closePopup();
        App.Objects.Location.removeNearGeofences();
        App.Forms.Location.form.model.set("latitude", geoMarker._latlng.lat);
        App.Forms.Location.form.model.set("longitude", geoMarker._latlng.lng);
        App.Objects.Location.afterPopulateForm(App.Forms.Location.form.model);
        Monet.Session.Location.Geofence.locationConfirmed = Monet.Session.Location.Geofence.locationNewPosition;
      });
    };

    this.choosenOne = e => {
        if (e.keyCode === 13) {
            this.selectItem();
        } else {
            if (e.keyCode === 9) {
                $(selector + " .streetSearchResult").hide();
                $(selector + " .streetSearchResult").html();
                $(selector + " input[name='searchStreet']").val("");
            }
        }
    };

    this.addSelectListeners = () => {
        const $select = $(`${selector} .streetSearchResult select`);
        $select.off('keydown')
            .on('keydown',this.choosenOne)
            .off('click').on("click", this.selectItem);

        $("#mapContainer").on("click", () => {
            this.canHide = true;
            $(selector + " .streetSearchResult").hide();
        });

    };

    this.renderGeocodeResult =  result => {

        const data = (Array.isArray(result)) ? result : [];

        const searchListBox = $(`${selector} .streetSearchResult`);

        const optGroup = document.createElement("optgroup");
        optGroup.setAttribute("id", "address");
        optGroup.setAttribute("class", "mapInfo");

        const selectAddress = document.createElement("select");
        selectAddress.setAttribute("multiple", true);
        selectAddress.appendChild(optGroup);
        searchListBox.html(selectAddress);
        searchListBox.show();

        if (data.length) {

            const mapInfoHTMLContainer = document.querySelector(`${selector} .mapInfo`);
            data.forEach(item => {
                const option = document.createElement("option");
                option.textContent = item.formatted_address;
                option.setAttribute("lat", item.geometry.location.lat());
                option.setAttribute("lng", item.geometry.location.lng());
                option.setAttribute("address", item.formatted_address);
                option.setAttribute("kind", "marker_address");
                mapInfoHTMLContainer.appendChild(option);
            });

            this.addSelectListeners();

            return;
        }

    };

    this.finish = () => {
        var theEnd = function (context, map) {
            return function (e) {
                if (e.keyCode === 27) {
                    for (var i in map._layers) {
                        if (map._layers[i].kind === "marker") {
                            map.removeLayer(map._layers[i]);
                        }
                    }
                }
            };
        }(this, map);
        $(selector).off("keydown", theEnd);
        $(selector).on("keydown", theEnd);
    };

    this.finish();

};
